import { useNavigate } from "react-router-dom";
import { Stethoscope, Building2, ChevronRight } from "lucide-react";

const LOGO = "https://content.webfactorysite.co.uk/20260113092111-Wales-Event-Logo.png?t=1768296071";

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden" data-testid="portal-landing">
      {/* Staff side */}
      <div className="bg-[#0F2547] text-white p-6 sm:p-12 lg:p-16 flex flex-col justify-between relative border-b lg:border-b-0 lg:border-r border-slate-800">
        <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
          style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #38BDF8 0, transparent 40%), radial-gradient(circle at 80% 90%, #00A499 0, transparent 40%)" }} />
        <div className="relative">
          <div className="bg-white rounded-xl inline-flex p-3 shadow-lg">
            <img src={LOGO} alt="Wales Event Medical Services" className="h-12 sm:h-14 w-auto" />
          </div>
        </div>
        <div className="relative py-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-12 w-12 rounded-xl bg-[#005EB8] grid place-items-center">
              <Stethoscope className="h-6 w-6" />
            </div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-sky-300">Staff Access</span>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4">
            Staff Portal
          </h1>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed max-w-md mb-8">
            Patient records, clinical observations and event medical reporting for the Wales Event Medical team.
          </p>
          <button
            data-testid="split-landing-staff-btn"
            onClick={() => navigate("/staff/login")}
            className="group inline-flex items-center gap-2 bg-[#005EB8] hover:bg-[#004a93] transition-colors text-white font-semibold px-7 py-4 rounded-lg text-base min-h-[48px]"
          >
            Sign in to Staff Portal
            <ChevronRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </button>
          <p className="mt-6 text-xs sm:text-sm text-slate-400 max-w-md border-l-2 border-[#005EB8] pl-4" data-testid="line-manager-notice">
            Access is by invitation only — speak to your line manager about getting a login.
          </p>
        </div>
        <div className="relative text-xs text-slate-500">
          Wales Event Medical Services · Professional Event Medical Cover UK
        </div>
      </div>

      {/* Client side */}
      <div className="text-slate-900 p-6 sm:p-12 lg:p-16 flex flex-col justify-between relative bg-gradient-to-br from-emerald-50 via-teal-50 to-sky-50">
        <div />
        <div className="py-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-12 w-12 rounded-xl bg-[#007F3B] grid place-items-center text-white">
              <Building2 className="h-6 w-6" />
            </div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-700">Client Access</span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4 text-[#0F2547]">
            Client Portal
          </h2>
          <p className="text-slate-600 text-sm sm:text-base leading-relaxed max-w-md mb-8">
            Event organisers: view your quotes and invoices, download your medical plans and documents, and book your next event.
          </p>
          <button
            data-testid="split-landing-client-btn"
            onClick={() => navigate("/portal/login")}
            className="group inline-flex items-center gap-2 bg-[#007F3B] hover:bg-[#006331] transition-colors text-white font-semibold px-7 py-4 rounded-lg text-base min-h-[48px]"
          >
            Sign in to Client Portal
            <ChevronRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </button>
          <p className="mt-6 text-xs sm:text-sm text-slate-500 max-w-md border-l-2 border-[#007F3B] pl-4" data-testid="client-portal-notice">
            Access is by invitation — Wales Event Medical Services emails you a link to set your password.
          </p>
        </div>
        <div className="text-xs text-slate-500">
          Need medical cover for your event? <a href="https://waleseventmedical.co.uk/get-a-free-quote" target="_blank" rel="noreferrer" className="text-[#005EB8] font-semibold hover:underline">Get a free quote</a>
        </div>
      </div>
    </div>
  );
}
